var map = {
	"./Australia.jpg": 5272,
	"./Austria.jpg": 4074,
	"./Canada.jpg": 5836,
	"./China.jpg": 1396,
	"./Eurozone.jpg": 1103,
	"./France.jpg": 4632,
	"./Germany.jpg": 6003,
	"./HongKong.jpg": 8784,
	"./Italy.jpg": 2315,
	"./Japan.jpg": 7295,
	"./Korea.jpg": 6964,
	"./Malaysia.jpg": 4126,
	"./NewZealand.jpg": 8616,
	"./Singapore.jpg": 6943,
	"./Switzerland.jpg": 2011,
	"./UK.jpg": 4082,
	"./US.jpg": 4152,
	"./china1.jpg": 4742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;